import React from "react";
import { getVastuInfo, getZoneColor } from "@/lib/vastu";
import { getPadaInfo } from "@/lib/padas";

export default function SectorTable({ sectors, hoveredIndex, onHover, onClick }) {
  return (
    <div className="overflow-auto max-h-[280px] rounded-lg border border-slate-800 bg-slate-950/40">
      <table className="w-full border-collapse text-left text-xs" data-testid="sector-data-table">
        <thead className="sticky top-0 bg-slate-950 border-b border-slate-800">
          <tr>
            <Th>#</Th>
            <Th>Dir</Th>
            <Th>Sanskrit</Th>
            <Th>Element</Th>
            <Th>Angle</Th>
          </tr>
        </thead>
        <tbody>
          {sectors.map((s) => {
            const info = getVastuInfo(s.code);
            const pada = getPadaInfo(s.code);
            const active = hoveredIndex === s.index;
            return (
              <tr
                key={s.index}
                data-testid="sector-table-row"
                className={`border-b border-slate-900 cursor-pointer transition-colors ${active ? "bg-slate-800/60" : "hover:bg-slate-900/60"}`}
                onMouseEnter={() => onHover && onHover(s.index)}
                onMouseLeave={() => onHover && onHover(null)}
                onClick={() => onClick && onClick(s.index)}
              >
                <Td mono>{s.index + 1}</Td>
                <Td>
                  <span className="inline-flex items-center gap-1.5">
                    <span className="h-2 w-2 rounded-full" style={{ background: pada ? pada.gradeMeta.color : getZoneColor(s.code) }} />
                    <span className="font-mono font-semibold text-slate-100">{s.code}</span>
                  </span>
                </Td>
                <Td><span className="font-display text-slate-300">{pada ? pada.deity : info.sanskrit}</span></Td>
                <Td><span className="text-slate-400">{pada ? pada.gradeMeta.label : info.element}</span></Td>
                <Td mono><span className="text-slate-400">{s.angleRange}</span></Td>
              </tr>
            );
          })}
        </tbody>
      </table>
      {sectors.length === 0 && (
        <div className="p-6 text-center text-slate-500 text-sm">
          Draw a polygon to compute sectors
        </div>
      )}
    </div>
  );
}

const Th = ({ children }) => (
  <th className="px-3 py-2 font-mono text-[10px] uppercase tracking-widest text-slate-500 font-medium">{children}</th>
);
const Td = ({ children, mono }) => (
  <td className={`px-3 py-2 ${mono ? "font-mono" : ""}`}>{children}</td>
);
